import { render } from "./MoveWarehouseLocationView.vue?vue&type=template&id=107fbc18&ts=true"
import script from "./MoveWarehouseLocationView.vue?vue&type=script&lang=ts"
export * from "./MoveWarehouseLocationView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__